import React from "react";
import { ToastContainer } from "react-toastify";
import { ManageEvents } from "../components/ExternalEvents/ManageEvents";

export const EventsManage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageEvents />
        </div>
      </div>
    </div>
  );
};
